export enum DIALOG_EVENT {
  CANCEL,
  CONFIRM,
}
